<template>
    <div class="notFound" @click="goBack()"></div>
</template>

<script>
export default {
    methods: {
        goBack() {
            history.go(-1);
        }
    }
}
</script>

<style scoped>
    .notFound{
        background: url('../../assets/images/views/404.jpg') center center no-repeat;
        width: 100%;
        height: 500px;
        cursor: pointer;
    }
</style>